interface Props {
  data: any;
}

export const ConsentName = ({ data }: Props) => {
  return (
    <div style={{ margin: '2rem' }}>
      <div id={`consent-signatory-name`} style={{ marginTop: '1rem' }}>
        <label style={{ fontWeight: 'bold' }}>Name:</label>
        <label style={{ marginLeft: '8px' }}>{data?.metadata?.signatory}</label>
      </div>
    </div>
  );
};
